module.exports = __webpack_public_path__ + "img/BRIDGE.e7097299.jpg";